// CSS imports (keep order)
import "./css/Fonts.css";
import "./css/Root.css";
import "./css/Mono.css";
import "./css/Init.css";
// End CSS imports
import { Suspense } from "react";
import { AuthProvider } from "./auth/AuthContext";
import { FormLoader } from "./features/commons/Form/Form";
import { HelperProvider } from "./features/commons/Helper/HelperContext";
import { ModalProvider } from "./features/commons/Modal/ModalContext";
import RouterProvider from "./routes/Router";
import { ThemeProvider } from "./theme/ThemeContext";
import { ToastsProvider } from "./features/commons/Toasts/ToastsContext";
import initSentry from "./sentry";

initSentry();

export default function App() {
  return (
    <Suspense fallback={<SuspenseFallback />}>
      <AuthProvider>
        <ThemeProvider>
          <ToastsProvider>
            <ModalProvider>
              <HelperProvider>
                <RouterProvider />
              </HelperProvider>
            </ModalProvider>
          </ToastsProvider>
        </ThemeProvider>
      </AuthProvider>
    </Suspense>
  );
}

function SuspenseFallback() {
  return (
    <div
      style={{
        position: "fixed",
        right: "0",
        left: "0",
        top: "0",
        bottom: "0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "progress",
      }}
    >
      <FormLoader />
    </div>
  );
}
